"use client";

import { Skeleton } from "@/components/ui/skeleton";
import dynamic from "next/dynamic";

export const Editor = dynamic(() => import("./index"), {
    ssr: false,
    loading: BlogPostSkeleton,
});
const getRandomInt = (min: number, max: number) => {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
};
function BlogPostSkeleton() {
    const getRandomWidth = () => {
        return Math.floor(Math.random() * 100) + "%";
    };
    const randomNumber = getRandomInt(1, 20);
    return (
        <div className="w-full animate-pulse p-3">
            {/* Title */}
            <div className="mb-4">
                <Skeleton className="h-8 w-52 bg-gray-700" />
                {/* Hello this is testing blogs */}
            </div>

            {/* Subtitle/Tagline */}
            <div className="mb-2">
                <Skeleton className="h-6 w-40 bg-gray-700" />
                {/* Testing shit lets see what happens */}
            </div>

            {/* Links section */}
            <div className="mb-3">
                <Skeleton className="h-5 w-24 bg-gray-700" />
                {/* testing a links */}
            </div>

            {/* Main content paragraph (multiple lines) */}
            <div className="space-y-2">
                {[...Array(randomNumber)].map((_, index) => (
                    <Skeleton
                        key={index}
                        className="h-4 bg-gray-700"
                        style={{ width: getRandomWidth() }}
                    />
                ))}
            </div>
        </div>
    );
}
